module.exports = __webpack_public_path__ + "img/head-no.48b474bc.png";